import styled, { css } from 'styled-components'
import { isTablet } from 'react-device-detect'

export const Container = styled.div`
  --hd_img: 450px;
  --hd_img_max: 600px;
  --hd_gap: 25px;

  --fk_img: 600px;
  --fk_img_max: 840px;
  --fk_gap: 50px;

  /* Tablet override - smaller images on iPad */
  ${isTablet &&
  css`
    --hd_img: 350px;
    --hd_img_max: 500px;
    --hd_gap: 20px;
  `}

  --hd_h1_size: 34px;
  --hd_h2_size: 22px;
  --hd_p_size: 18px;
  --hd_settlement_size: 16px;
  --hd_inventory_size: 12px;
  --hd_selector_size: 17px;

  --fk_h1_size: 46px;
  --fk_h2_size: 30px;
  --fk_p_size: 24px;
  --fk_settlement_size: 21px;
  --fk_inventory_size: 16px;
  --fk_selector_size: 22px;

  min-height: 350px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.2);
  font-size: 12px;
  display: flex;
  align-items: center;
  border-radius: 24px;
  padding: calc(var(--hd_gap) * 2) var(--hd_gap) var(--hd_gap) var(--hd_gap);

  .wrapper {
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-template-rows: 200px;
    opacity: 0;
    transform: translateY(30px);
    gap: var(--hd_gap);

    &.fade-in {
      animation: fade-in-y30 0.3s 0.3s ease forwards;
    }

    &.fade-out {
      animation: fade-out-y30 0.3s ease forwards;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    font-size: 14px;

    .wrapper {
      grid-template-columns: var(--hd_img) var(--hd_img) auto;
      grid-template-rows: 1fr;
      grid-row-gap: 0px;

      h1 {
        margin: 15px 0;
      }
    }
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.md} 
        && min-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    font-size: 16px;
    padding: 100px 40px 40px 40px;
    width: unset;

    .wrapper {
      height: 600px;
      gap: 40px;
      grid-template-columns: var(--hd_img) var(--hd_img) auto;
      grid-template-rows: 1fr;
    }
  }

  /* Mobile Card */
  @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    padding: 60px 24px 24px;
    .wrapper {
      grid-template-columns: 40% 60%;
      grid-template-rows: 1fr;
      grid-row-gap: 0px;
      gap: 0;
      width: 100%;
    }
  }
  /* 4k Card */
  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    padding: calc(var(--fk_gap) * 2) var(--fk_gap) var(--fk_gap) var(--fk_gap);
    .wrapper {
      min-height: var(--fk_img);
      grid-template-columns: var(--fk_img) var(--fk_img) auto;
      grid-column-gap: var(--fk_gap);
    }
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-row: 1fr 100px;
  align-items: center;
  grid-row: 1 / 1;
  grid-column: 1 / 1;
  width: var(--hd_img);

  .selectorButtonWrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
  }
  .selector-text {
    font-size: var(--hd_selector_size);
  }
  .selector-numbered-text {
    font-family: ${({ theme }) => theme.font.medium};
    font-size: var(--hd_selector_size);
  }

  img {
    grid-row: 1 / 1;
    grid-column: 1 / 1;
    align-self: start;
    max-width: 100%;
    width: auto;
    height: var(--hd_img);
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.md}) {
    img {
      max-width: 100%;
    }
  }

  /* MOBILE Motif Image */
  @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    width: 100%;
    padding: 0;
    grid-template-rows: 1fr 1rem;

    img {
      width: 100%;
      height: auto;
    }
    .selectorButtonWrapper {
      font-size: 16px;
      line-height: 20px;

      .selector-text,
      .selector-numbered-text {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
  /* 4k Motif Image */
  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    width: 100%;
    padding: 0;
    grid-template-rows: 1fr auto;
    gap: var(--fk_gap);

    img {
      width: 100%;
      height: auto;
    }
    .selectorButtonWrapper {
      font-size: 16px;
      line-height: 40px;
      min-height: 120px;
    }
    .selector-text,
    .selector-numbered-text {
      font-size: var(--fk_selector_size);
    }
  }
`

export const InfoWrapper = styled.div`
  height: var(--hd_img_max);
  max-height: var(--hd_img_max);
  overflow-x: hidden;
  overflow-y: hidden;
  grid-column: 2 / 2;
  grid-row: 1 / span 2;

  .data {
    overflow-x: visible;
    margin: 22px 0 10px 0;

    h1 {
      font-size: var(--hd_h1_size);
      line-height: 1.2;
      font-family: ${({ theme }) => theme.font.light};
      color: ${({ theme }) => theme.colors.black95};
      margin: 14px 0 14px 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    h2 {
      font-size: var(--hd_h2_size);
      line-height: 1.2;
      font-family: ${({ theme }) => theme.font.regular};
      color: ${({ theme }) => theme.colors.black95};
      margin: 10px 0 10px 0;
    }

    p {
      color: ${({ theme }) => theme.colors.black70};
      letter-spacing: 0.62px;
      margin: 0;
    }
  }

  .description {
    width: 100%;
    height: 490px;
    white-space: pre-wrap;
    font-size: var(--hd_p_size);
    line-height: 1.33;
    font-family: ${({ theme }) => theme.font.light};
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey40};
    letter-spacing: 0.5px;
    display: block;
    overflow-y: clip;
    padding: 0;
    margin: 0;
  }
  .year-settlement-info {
    padding: 6px;
    border-radius: 3px;
    font-size: var(--hd_settlement_size);
    font-weight: 500;
    line-height: 1.6;
    font-family: ${({ theme }) => theme.font.regular};
    color: ${({ theme }) => theme.colors.black95};
    letter-spacing: 0.5px;
    margin-bottom: 10px;
    background-color: ${({ theme }) => theme.colors.bgMediumGrey};
    display: inline;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
  }
  .year-settlement-info:empty {
    display: none;
  }

  /* MOBILE Motif Info */
  @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    padding: 0 0 0 24px;
    height: auto;
    max-height: none;
    overflow-y: visible;
    .description {
      height: auto;
    }
    .data {
      .selectorButtonWrapper button {
        gap: 0;
      }
      .selector-text {
        font-size: 16px;
        line-height: 20px;
      }
      .selector-numbered-text {
        font-size: 16px;
        line-height: 20px;
        font-family: ${({ theme }) => theme.font.medium};
      }

      h1 {
        font-size: 32px;
        line-height: 125%;
      }
      h2 {
        font-size: 24px;
        line-height: 30px;
      }
      .year-settlement-info {
        font-size: 17px;
        line-height: 1.6;
      }
    }
  }
  /* 4k info */
  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    padding: 0;
    height: 680px;
    max-height: 680px;
    .description {
      font-size: 24px;
    }
    .data {
      margin-top: 40px;
      .selectorButtonWrapper button {
        gap: 0;
      }
      .selector-text {
        font-size: var(--fk_selector_size);
        line-height: 20px;
      }
      h1 {
        font-size: var(--fk_h1_size);
      }
      h2 {
        font-size: var(--fk_h2_size);
      }
      .description {
        font-size: var(--fk_p_size);
      }
      .year-settlement-info {
        font-size: var(--fk_settlement_size);
        line-height: 1.6;
      }
    }
  }
`

export const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .image-section {
    max-height: var(--hd_img);
    min-height: var(--hd_img);
    height: var(--hd_img);
    min-width: var(--hd_img);
    max-width: var(--hd_img_max);
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    overflow: hidden;
  }

  .main-photo {
    display: block;
    height: var(--hd_img);
    width: auto;
    min-height: var(--hd_img);
    max-width: var(--hd_img_max);
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .info-section {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: center;
    white-space: nowrap;

    .inventory-number {
      font-size: var(--hd_inventory_size);
      font-family: ${({ theme }) => theme.font.regular};
      color: ${({ theme }) => theme.colors.black95};
    }
    .displayType {
      font-size: var(--hd_inventory_size);
      font-family: ${({ theme }) => theme.font.medium};
    }

    .link-to-motif {
      display: inline-block;
      padding: 8px 12px 8px 36px;
      margin: 0 4px;
      border-radius: 4px;
      text-decoration: none;
      color: #333;
      font-family: ${({ theme }) => theme.font.regular};
      font-size: var(--hd_inventory_size);
      word-break: break-all;
      position: relative;
      white-space: nowrap;
      
      button {
        display: flex;
        align-items: center;
        background: none;
        border: none;
        font-family: ${({ theme }) => theme.font.regular};
        font-size: var(--hd_inventory_size);
        color: #333;
        gap: 8px;
      }

      .share-icon {
        width: calc(var(--hd_inventory_size) * 2);
        height: calc(var(--hd_inventory_size) * 2);
      }
    }
  }

  .thumbnail-gallery {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    border: none;
    gap: 12px;
    width: 100%;
    min-width: 0;

    .thumbnail {
      max-height: 90px;
      width: auto;
      flex: 0 0 auto;
      min-width: 60px;
      object-fit: contain;
      border-radius: 4px;
      cursor: pointer;
      transition: transform 0.2s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  /* MOBILE Motif Gallery */
  @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    .image-section,
    .main-photo {
      height: auto;
      min-height: unset;
      max-height: unset;
      min-width: 100%;
      max-width: 100%;
      width: 100%;
    }
  }
  /* 4k Gallery */
  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    
    .image-section {
      max-height: var(--fk_img);
      min-height: var(--fk_img);
      height: var(--fk_img);
      min-width: unset;
      max-width: var(--fk_img_max);
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .main-photo {
      object-fit: contain;
      height: var(--fk_img);
      width: auto;
      min-width: unset;
      min-height: var(--fk_img);
      max-width: var(--fk_img_max);
      max-height: unset;
    }
    .info-section {
      gap: 16px;

      .inventory-number {
        font-size: var(--fk_inventory_size);
      }
      .displayType {
        font-size: var(--fk_inventory_size);
      }

      .link-to-motif {
        display: inline-block;
        padding: 12px var(--fk_inventory_size) 12px 54px;
        margin: 0 8px;
        border-radius: 8px;
        font-size: var(--fk_inventory_size);
        
        button {
          font-size: var(--fk_inventory_size);
          gap: var(--fk_inventory_size);
        }

        .share-icon {
          width: calc(var(--fk_inventory_size) * 2);
          height: calc(var(--fk_inventory_size) * 2);
        }
    }
  }
`
